// Saved screenshots and strategy tags are optional. Scores, round results and
// the five player/agent pairings are the editable match-statistics information.
export function isCompleteTeamStats(data) {
  const score = value => (typeof value === 'number' || typeof value === 'string')
    && String(value).trim() !== '' && Number.isInteger(Number(value)) && Number(value) >= 0;
  if (!score(data?.score?.us) || !score(data?.score?.them)) return false;
  if (!['atk','def'].every(side => ['r1','r2','r3'].every(round => typeof data?.roundWins?.[side]?.[round] === 'boolean'))) return false;
  const players = data?.players;
  if (!Array.isArray(players) || players.length !== 5) return false;
  const identities = players.map(player => {
    const uid = String(player?.uid || '').trim(), name = String(player?.username || '').trim().toLowerCase();
    return uid ? `uid:${uid}` : name ? `name:${name}` : '';
  });
  const agents = players.map(player => String(player?.agent || '').trim().toLowerCase());
  return identities.every(Boolean) && agents.every(Boolean)
    && new Set(identities).size === 5 && new Set(agents).size === 5;
}
